const normalizeDocument = value =>
  value ? String(value).toUpperCase().replace(/[^A-Z0-9]/g, '') : '';

const isCpf = value => /^\d{11}$/.test(normalizeDocument(value));

const isCnpj = value => /^[A-Z0-9]{12}\d{2}$/.test(normalizeDocument(value));

const isCpfOrCnpj = value => isCpf(value) || isCnpj(value);

const resolvePersonTypeByDocument = value => {
  if (isCpf(value)) return 'PF';
  if (isCnpj(value)) return 'PJ';
  return null;
};

const formatCpf = value => {
  const document = normalizeDocument(value);
  if (!isCpf(document)) return value || '';

  return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
};

const formatCnpj = value => {
  const document = normalizeDocument(value);
  if (!isCnpj(document)) return value || '';

  return document.replace(
    /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
    '$1.$2.$3/$4-$5'
  );
};

const formatDocument = value => {
  if (isCpf(value)) return formatCpf(value);
  if (isCnpj(value)) return formatCnpj(value);
  return value || '';
};

const maskSensitiveCpf = value => {
  const document = normalizeDocument(value);
  if (!isCpf(document)) return value || '';

  return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '***.$2.$3-**');
};

const maskSensitiveDocument = value => {
  if (isCpf(value)) return maskSensitiveCpf(value);
  if (isCnpj(value)) return formatCnpj(value);
  return value || '';
};

export {
  normalizeDocument,
  isCpf,
  isCnpj,
  isCpfOrCnpj,
  resolvePersonTypeByDocument,
  formatCpf,
  formatCnpj,
  formatDocument,
  maskSensitiveDocument
};
